'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _uploader = require('./uploader');

var _uploader2 = _interopRequireDefault(_uploader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('app-uploader', _uploader2.default);


//////////////////
// WEBPACK FOOTER
// ./src/components/index.js
// module id = 591
// module chunks = 14